import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/admin/')({
  component: AdminIndex,
});

function AdminIndex() {
  return <Navigate to="/admin/users" replace />;
}
